export default {
  props: {
    showType: Boolean,
    types: Array,
    typesLocaleKey: String,
    typeText: { type: String, default: 'label' },
    typeValue: { type: String, default: 'value' },
    typeDisabled: { type: String, default: 'disabled' },
  },

  computed: {
    allTypes() {
      const typeLocales = this.$t(this.typesLocaleKey);
      return this.types || _.map(_.keys(typeLocales), k => ({ label: typeLocales[k], value: k }));
    },
  }
};
